module.exports = __webpack_public_path__ + "static/img/zhidao.e4255e44.png";